<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 22/9/2020
  -->

<template>
	<FormRow
		:prop="prop"
		:title="title"
		v-bind="attrsNoListeners"
		:labelMinWidth="labelMinWidth"
		:tooltipText="tooltipText"
		:tooltip-position="tooltipPosition"
		:showDivider="showDivider">

		<!--        <div class="">-->

		<qw-switch
			v-model="valueData"
			v-bind="attrsVue2"
			:disabled="disabled"
			:inactive-text="inactiveText"
			:active-text="activeText"
			:inactive-value="inactiveValue"
			:active-value="activeValue"
			@change="notifyValueChanged">
			{{ name }}
		</qw-switch>

	</FormRow>

</template>

<script>
import BaseFormRow from "@/core/components/Form/Base/BaseFormRow.vue"
import FormRow from "@/core/components/Form/Base/FormRow.vue";

export default {
	name: "FormSwitchRow",
	components: {FormRow},
	extends: BaseFormRow,

	inheritAttrs: false,

	props: {
		name: String,
		labelMinWidth: {Number, default: 0},
		tooltipPosition: String,
		disabled: Boolean,
		inactiveText: String,
		activeText: String,
		inactiveValue: {default: false},
		activeValue: {default: true},


	},


}
</script>

<style lang="scss">


</style>
